import { motion } from 'framer-motion';

const InfiniteLogoSlider = ({ logos, speed = 20 }) => {
  const repeatedLogos = [...logos, ...logos, ...logos, ...logos]; 

  return (
    <div className="relative overflow-hidden w-full h-16">
      <motion.div
        className="flex gap-16 w-max"
        animate={{ x: ['0%', '-50%'] }}
        transition={{
          duration: speed,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        {repeatedLogos.map((logo, index) => (
          <div
            key={index}
            className="flex items-center justify-center w-[100px] h-16 shrink-0"
          >
            <img
              src={logo.src}
              alt={logo.name}
              width={100}
              height={40}
              className="object-contain max-h-12 w-auto"
            />
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default InfiniteLogoSlider;
